"use strict";

require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CartSelector = {
  COMMON: {
    RECALCULATE_BTN: '.js_cart_recalculate',
    CONTENT_CONTAINER: '.js_cart_content_container',
    CONTENT: '.js_cart_content',
    SINGLE_PRODUCT_CHECBKOX: '.js_cart_checkbox',
    SINGLE_PRODUCT_REMOVE_BTN: '.js_cart_remove_single_product',
    DELIVERY_DATE_INPUT: '#prefered-delivery-date',
    PRODUCT_PRICE_CHECKER_INPUT: '.product_price_checker',
    TOTAL_PRICE: '.product-total-price',
    PRODUCT_SUM_WEIGHT: '.js_sum_weight'
  },
  HEADER: {
    TOTAL_VALUE: '.cart-total',
    QUANTITY_COUNTER: '.js_cart_count',
    TOGGLER: '.cart-btn',
    MAIN_COUNT: '.main_cart_count:visible',
    VALUE: '#cartValue'
  }
};